/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import { KTSVG } from '../../../helpers'

type Props = {
  className?: string
  functionSubmit?: any
  selectedOption: string
  selectedKey?: string
}

const sourceTypeFilterOptionDefs = [
  { key: '', labelKey: 'All Sources' },
  { key: 'MentionsCommentsAndConversations', labelKey: 'Mentions, Comments and Conversations' },
  { key: 'MentionsAndComments', labelKey: 'Mentions and Comments' },
  { key: 'Mentions', labelKey: 'Mentions' },
  { key: 'Comments', labelKey: 'Comments' },
  { key: 'Conversations', labelKey: 'Conversations' },
  { key: 'AccountSharings', labelKey: 'Account Sharings' },
]

const sourceTypeFilterDefaultKey = 'MentionsCommentsAndConversations'

const getSourceTypeFilterLabel = (key: string) =>
  LanguageHelp(sourceTypeFilterOptionDefs.find((item) => item.key === key)?.labelKey ?? key)

const changeDropDownText = (e: React.MouseEvent<Element, MouseEvent>) => {
  const target = e.target as HTMLInputElement;
  target.parentElement!.parentElement!.parentElement!.children[0].children[0].textContent = target.textContent
}

const DropdownFilterSourceType: FC<Props> = ({ 
  className = '', 
  functionSubmit, 
  selectedOption,
  selectedKey = sourceTypeFilterDefaultKey,
}) => {
  const displayLabel = selectedOption || getSourceTypeFilterLabel(selectedKey)

  return (
    <div className= {className}>
      <a href='#' className='btn btn-light btn-active-light-primary btn-sm' data-kt-menu-trigger='click' data-kt-menu-placement='bottom-end'>
        <div style={{ display: 'unset' }}>{displayLabel}</div>
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4 scroll-y mh-250px px-2' data-kt-menu='true'>
        {sourceTypeFilterOptionDefs.map((item) => (
        <div className='menu-item px-3' key={item.key || 'all-sources'}>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit(item.key, 'sourceType'); changeDropDownText(e); }} >
            {LanguageHelp(item.labelKey)}
          </a>
        </div>
        ))}
      </div>
      {/* end::Menu */}
    </div>
  )
}

export {
  DropdownFilterSourceType,
  sourceTypeFilterOptionDefs,
  sourceTypeFilterDefaultKey,
  getSourceTypeFilterLabel,
}
